export default {"src":"https://static.carma.com.au/_next/static/media/carma-logo.1a83e197.svg","height":74,"width":122,"blurWidth":0,"blurHeight":0};